module.exports = __webpack_public_path__ + "66db5e40d64fcbf4e2a96ecef1469c20.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/jan-lehnardt.jpg
 ** module id = 412
 ** module chunks = 0
 **/